import api from "./api";

export const registerUser = async (data) => {
  const response = await api.post('/api/users/register', data);
  return response.data;
};

export const loginUser = async (data) => {
  const response = await api.post('/api/users/login', data,
    {
      withCredentials: true
    }
  );
  return response.data;
};

export const logoutUser = async () => {
  const response = await api.post('/api/users/logout', null, {
    withCredentials: true
  });
  return response.data;
}

export const getMyLoginUser = async () => {
  const response = await api.get('/api/users/login');
  return response.data;
}

export const getUserDetails = async () => {
  const response = await api.get('/api/users/user-details');
  return response.data;
};

export const updateUserDetails = async (data) => {
  const response = await api.put('/api/users/user-details', data);
  return response.data;
};

export const updatePassword = async (data) => {
  const response = await api.put('/api/users/update-password', data);
  return response.data;
};

export const updateUserLanguage = async (language) => {
  const response = await api.put("/api/users/language", { language });
  return response.data;
};

export const resendConfirmationEmail = async (email) => {
  const response = await api.post("/api/users/resend-confirmation", { email });
  return response.data;
};


export const confirmEmail = async (token) => {
  const response = await api.post('/api/users/confirm-email', {token});
  return response.data;
};

export const forgotPassword = async (data) => {
  return await api.post('/api/users/forgot-password', data);
};

export const resetPassword = async (data) => {
  return await api.post('/api/users/reset-password', data);
};

export const createSubscription = async (data) => {
  const response = await api.post('/api/subscription/create-subscription', data);
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await api.post('/api/subscription/cancel-subscription');
  return response.data;
}

export const reactivateSubscription = async () => {
  const response = await api.post('/api/subscription/reactivate-subscription');
  return response.data;
}

export const updateSubscription = async (data) => {
  const response = await api.post('/api/subscription/update-subscription', data);
  return response.data;
}

export const getMySubscriptionAndQuota = async () => {
  const response = await api.get('./api/subscription/user-subscription');
  return response.data;
}

export const getProfile = async (id) => {
  const response = await api.get(`/api/profiles/${id}`)
  return response.data;
}

export const createProfile = async (data) => {
  const response = await api.post(`/api/profiles`, data);
  return response.data;
};

export const updateProfile = async (id, profileData) => {
  const response = await api.put(`/api/profiles/${id}`, profileData);
  return response.data;
};

export const deleteProfile = async (id) => {
  const response = await api.delete(`/api/profiles/${id}`);
  return response.data;
};

export const uploadProfilePhoto = async (id, photo) => {
  const formData = new FormData();
  formData.append('photo', photo);
  const response = await api.post(`/api/profiles/${id}/photo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};
